import request from '@/utils/request';

export function administratorsAPI() {
  return {
    // 列表
    administratorsList: params => {
      return request({
        url: '/admin/auth/admin/index',
        method: 'get',
        params,
      });
    },
    // 角色组
    roleList: params => {
      return request({
        url: '/admin/group/option',
        method: 'get',
        params,
      });
    },
    //新增
    adminAdded: data => {
      return request({
        url: '/admin/auth/admin/edit',
        method: 'post',
        data
      });
    },
      // 详情数据
      detailsList: params => {
        return request({
          url: `/admin/auth/admin/info?id=${params}`,
          method: 'get',
        });
      },
  };
}
